// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightPreprintReport-cls1_8Q-","cls2":"CiterightPreprintReport-cls2_cAQ CiterightPreprintReport-cls1_8Q-"};